import React, { useContext } from 'react';
import classnames from 'classnames';

import Context from "../context/context";


const NavItem = props => {
  const {activeFilters } = useContext(Context);
  const {widget, toggleFilterNav} = props;

  let filter_count = 0;
  if (typeof widget.filters != "undefined"){
    filter_count = activeFilters[widget.filters[0].name].value.length;
  }

  return (
    <>
    <div
      className={classnames('filter-section-trigger filter-nav-item ', {
        open: widget.open
      })}
      onClick={() => toggleFilterNav(widget)}
    >
    <div className="filter-nav-item-top">
      <div className="filter-trigger-name  filter-nav-title">{widget.title}</div>
      <span aria-hidden="true" className="sr-only"> (</span>
      <span
      className={classnames('filter-count', {
        active: filter_count > 0
      })}>{filter_count}</span>
      <span className="sr-only" aria-hidden="true"> filters selected)</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 23.5C6.42487 23.5 1.5 18.5751 1.5 12.5C1.5 6.42487 6.42487 1.5 12.5 1.5C18.5751 1.5 23.5 6.42487 23.5 12.5C23.5 18.5751 18.5751 23.5 12.5 23.5ZM12.5 21.5C17.4706 21.5 21.5 17.4706 21.5 12.5C21.5 7.52944 17.4706 3.5 12.5 3.5C7.52944 3.5 3.5 7.52944 3.5 12.5C3.5 17.4706 7.52944 21.5 12.5 21.5ZM7.5 13.5H14.0858L11.7929 15.7929L13.2071 17.2071L17.9142 12.5L13.2071 7.79289L11.7929 9.20711L14.0858 11.5H7.5V13.5Z" fill="white"/>
      </svg>
    </div>


    </div>
    </>
  )
}

export default NavItem;
